import styled from 'styled-components/macro'

export const CompoundLabel = styled.h5`
  width: 100%;
  text-align: left;
  margin: 0;
  margin-top: 10px;
`
